import { SalesLead } from '../../models/SalesLead'
import Calendar from '../shared/calendar'
import { ApiSalesLead } from './apiTypes'

export class SalesLeadApiMapper {
	static toSalesLead(salesLead: SalesLead): ApiSalesLead {
		const apiLead: ApiSalesLead = {
			destination_id: salesLead.destinationId,
			user_id: salesLead?.userInfo.id,
			user_name: salesLead?.userInfo.name,
			user_email: salesLead?.userInfo.email,
			user_phone: salesLead?.userInfo.phone,
			user_country_id: salesLead.userInfo.countryId,
			itinerary_id: salesLead.tripInfo.id,
			start_date: this.toDateString(salesLead.tripInfo?.startDate),
			end_date: this.toDateString(salesLead.tripInfo?.endDate),
			min_budget: salesLead.tripInfo?.minBudget,
			max_budget: salesLead.tripInfo?.maxBudget,
			num_travelers: salesLead.tripInfo?.numTravelers,
			communications: salesLead?.userInfo.communications,
			origin_url: salesLead?.originUrl,
			channel: 'product',
			utm_source: 'product',
			utm_medium: salesLead?.utmInfo?.utmMedium,
			utm_campaign: salesLead?.utmInfo?.utmCampaign,
		}
		return apiLead
	}

	private static toDateString(date: Date | undefined): string {
		if (!date) return ''
		return Calendar.getDateStringTwoDigit(date)
	}
}
